var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeSmClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48303 13.1649V3.27465C1.48303 2.17009 2.37846 1.27454 3.48303 1.27454H23.483C24.5876 1.27454 25.483 2.16996 25.483 3.27453V13.165C25.483 14.2696 24.5955 15.165 23.4909 15.165H3.48207C2.37751 15.165 1.48303 14.2695 1.48303 13.1649Z",
    fill: "white",
    stroke: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1317 8.08472L1.7998 14.2929M16.8344 8.08472L25.2307 14.3409",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9907 2.00573L16.835 8.08463H10.1317L1.94202 1.98096",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1197 3.70982C9.45659 3.73926 8.4631 5.21107 8.48334 6.40325C8.52749 8.98261 11.3875 11.3246 13.4829 12.8112C15.525 11.2511 18.5266 8.806 18.4825 6.22847C18.4622 5.0363 17.4155 3.59943 15.7542 3.62886C14.825 3.64542 14.0661 4.39974 13.4829 5.11357C12.8758 4.41997 12.0488 3.6951 11.1197 3.70982Z",
    fill: "#F7CFDA",
    stroke: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSmClosed);
export default __webpack_public_path__ + "static/media/envelope-sm-closed.0b49aa4d3332d72a4aa52625ff1289c5.svg";
export { ForwardRef as ReactComponent };